<template>
  <div class="app-main-layout">
    <a class="skip-link" href="#content">{{ $t('Перейти к основному содержанию') }}</a>
    <Header class="header-auth" />
    <main id="content" class="app-content" tabindex="-1">
      <div class="app-page">
        <slot />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Footer from '@/components/Footer'
import messages from '@/utils/messages'

export default {
  name: 'AuthLayout',
  components: {
    Header,
    Footer
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    error() {
      return this.$store.getters.error
    }
  },
  watch: {
    error(srvError) {
      this.$error(messages[srvError.code] || 'Что-то пошло не так')
    }
  }
}
</script>
